import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import { ContentContainer } from '../../../../components/Layout/ContentContainer';
import { Screen } from '../../../../components/Layout/Screen';

// Assets
import { brandColors, device } from '../../../../styles/variables';
import background from '../../../../assets/images/pages/neva/neva-map.png';
import TextBlock from '../../../../components/TextBlock';
import { AbsolutePositioned } from '../../../../components/Layout/AbsolutePositioned';
import Vimeo from '../../../../components/Vimeo';

const StyledScreen = Screen.extend`
  position: relative;
  overflow: hidden;
  background: ${brandColors.white};
  padding-top: 1px;
  margin-top: -1px;

  .title {
    padding: 156px 0 0;

    .subtext {
      max-width: 453px;
    }
  }
`;

const BackgroundOverlay = AbsolutePositioned.extend`
  background: url(${background}) center no-repeat;
  width: 100%;
  height: 100%;
  opacity: 0.9;
  background-size: 930px;
`;

const ContentHolder = AbsolutePositioned.extend`
  width: 100%;
  height: 100%;

  .vimeo {
    margin: 99px auto 0;
    max-width: 796px;
    max-height: 511px;
  }
`;

const TextBlockHolder = styled.div`
  @media ${device.laptop} {
    position: absolute;
    right: 150px;
    bottom: 8px;
  }
  @media ${device.laptopL} {
    bottom: 69px;
  }
`;

const CMSScreen = () => (
  <StyledScreen>
    <BackgroundOverlay />
    <ContentHolder>
      <Vimeo
        className="vimeo"
        playerLink="https://player.vimeo.com/video/289475667"
        title="Neva admin video"
        width={640}
        height={400}
      />
      <ContentContainer>
        <TextBlockHolder>
          <TextBlock width="378px" color={brandColors.blue}>
            <p>
              CMS functionality allows clients to post articles that users can comment on, like and
              share. They can also preview and download a range of data to send out targeted
              communications.
            </p>
          </TextBlock>
        </TextBlockHolder>
      </ContentContainer>
    </ContentHolder>
  </StyledScreen>
);

export default connect()(CMSScreen);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/MakingOfAnIndustryLeader/screens/CMS.jsx